import React from 'react'
import { formatPrice, getCurrencySymbol } from '@lib/utils/formatPrice'

interface CloudBadgeProps {
	badgeText?: string
	badgeValue: number
}

// A11Y Note: White text on #041E42 (bbx-style) background has 15.8:1 contrast ratio
// Automated tools may flag this as insufficient because they can't detect SVG image backgrounds
// Visual inspection confirms excellent contrast - this is a false positive from pa11y
function CloudBadge({ badgeText, badgeValue }: CloudBadgeProps) {
	return (
		<div className="subscription-plan-cloud-badge relative">
			{/* Background cloud image - SVG fill is #041E42 (bbx-style dark navy) */}
			<img src="/images/cloud.svg" alt="" aria-hidden="true" className="w-full h-auto" />
			<div
				className={`absolute right-0 left-0 flex flex-col gap-1 items-center justify-center text-white text-center leading-tight ${
					badgeText ? 'top-5' : 'top-8'
				}`}
			>
				{badgeText && <span className="text-base font-normal tracking-widest">{badgeText}</span>}
				<span className="text-4xl font-bold leading-none">
					{getCurrencySymbol()}
					{formatPrice((badgeValue || 0).toString())}
				</span>
				<span className="text-base font-normal tracking-widest">Value</span>
			</div>
		</div>
	)
}

export default CloudBadge
